import { brandConfig } from '../brandConfig';

export const ENTITY = {
  name: brandConfig.companyName,
  legalName: "ሒጅራ ትራቭል",
  schemaType: "TravelAgency",
  url: "https://hijratravelandtour.com",
  logo: "https://hijratravelandtour.com/logo.png",
  founded: "2011",
  founder: `${brandConfig.companyName} Team`,
  phone: "+251983848544",
  phoneDisplay: "+251 983 848 544",
  email: brandConfig.contactEmail,
  founderProfile: {
    jobTitle: "Founding Team",
    knowsAbout: ["Umrah Logistics", "Visa Processing", "Hajj Travel", "Ethiopian Tourism"],
    languages: ["English", "Amharic", "Arabic"]
  },
  address: {
    streetAddress: "Michael Taxi Mazoria",
    addressLocality: "Addis Ababa",
    addressRegion: "Addis Ababa",
    postalCode: "1000",
    addressCountry: "ET",
    fullText: "Michael Taxi Mazoria, Addis Ababa 1000, Ethiopia"
  },
  geo: {
    latitude: 8.969220639389423,
    longitude: 38.721515595683165
  },
  hours: [
    "Mo 00:00-23:59",
    "Tu 00:00-23:59",
    "We 00:00-23:59",
    "Th 00:00-23:59",
    "Fr 00:00-23:59",
    "Sa 00:00-23:59",
    "Su 00:00-23:59"
  ],
  rating: {
    value: "5.0",
    count: "5000",
    source: "Internal verified"
  },
  priceRange: "$$",
  currencies: "ETB, USD",
  paymentMethods: "Cash, Bank Transfer",
  sameAs: [
    brandConfig.facebookLink,
    brandConfig.instagramLink,
    "https://www.tiktok.com/@hijratravel"
  ],
  services: [
    {
      id: "01",
      name: "Visa Support",
      description: "Complete Umrah visa processing. Saudi, UAE, Schengen visas with full documentation assistance.",
      areaServed: "Addis Ababa, Ethiopia"
    },
    {
      id: "02",
      name: "Comfortable Hotels",
      description: "Premium hotels near Masjid al-Haram and Masjid an-Nabawi. All grades and budgets accommodated.",
      areaServed: "Saudi Arabia"
    },
    {
      id: "03",
      name: "Transport Facilities",
      description: "Airport transfers, intercity transport between holy cities, and full group logistics management.",
      areaServed: "Saudi Arabia & Ethiopia"
    },
    {
      id: "04",
      name: "Delicious Meals",
      description: "Authentic halal meals throughout your journey. Ethiopian and Arabian cuisine options available.",
      areaServed: "Saudi Arabia"
    },
    {
      id: "05",
      name: "Flight Tickets",
      description: "Domestic and international tickets to Saudi Arabia, UAE, Turkey, and worldwide destinations.",
      areaServed: "Addis Ababa, Ethiopia"
    },
    {
      id: "06",
      name: "Global Umrah Services",
      description: "Dedicated visa and hotel booking services for travelers arriving from Canada, USA, and Europe.",
      areaServed: "Global"
    }
  ],
  intentPhrases: [
    "Umrah packages Addis Ababa",
    "Best travel agency in Ethiopia",
    `${brandConfig.companyName} Umrah`,
    "Ethiopian travel agency for Hajj",
    "Umrah visa from Ethiopia",
    "Cheap Umrah packages from Addis Ababa",
    "Halal travel agency Ethiopia",
    "Hajj registration Addis Ababa"
  ],
  metrics: [
    { value: "5000+", label: "Pilgrims Served", sub: "Since 2011" },
    { value: "15", label: "Years of Service", sub: "Trusted agency" },
    { value: "100%", label: "Visa Success", sub: "Fast processing" },
    { value: "24/7", label: "Availability", sub: "Always open" }
  ],
  pageFAQ: {
    home: [
      {
        question: "What is included in your Umrah packages?",
        answer: "Our packages include visa processing, round-trip flight tickets, premium hotel accommodations in Mecca and Medina, transport logistics, and guided tours."
      },
      {
        question: "How long does the Umrah visa take?",
        answer: "Typically, Umrah visas are processed within 24 to 48 hours for applicants in Ethiopia, boasting a 100% success rate through our service."
      },
      {
        question: "Do you offer packages for families or children?",
        answer: "Yes, we offer dedicated Family Umrah Bundles with connecting rooms and special discounted packages for children traveling with their parents."
      },
      {
        question: "Can I travel from outside Ethiopia?",
        answer: "Absolutely! We offer Global Umrah Services tailored for travelers arriving from the USA, Canada, and Europe."
      },
      {
        question: "What are your opening hours?",
        answer: "We are open and available 24/7 for urgent travel needs and customer support."
      }
    ],
    services: [
      {
        question: "What travel services do you provide?",
        answer: "We offer Visa Processing, Flight Tickets, Hotel Booking in Saudi Arabia, transport logistics, and complete Umrah and Hajj packages."
      }
    ],
    packages: [
      {
        question: "How much is an Umrah package?",
        answer: "Our economy package starts at ETB 165,000 for a 15-day journey. We also offer VIP packages for ETB 195,000 and Visa-only services for ETB 40,000."
      }
    ]
  }
};
